const DISTANCE_TO_TOOLTIP = 19;
const WHOLESALE_PRICE_WIDTH = 74;

export function setTooltipPosition(tooltip, priceContainer, target) {
  const {
    top: priceContainerTop,
    left: priceContainerLeft,
    right: priceContainerRight,
  } = priceContainer.getBoundingClientRect();
  const {
    top: tooltipTop,
    left: tooltipLeft,
    right: tooltipRight,
    width: tooltipWidth,
  } = target.getBoundingClientRect();

  const rightDiff = priceContainerRight - tooltipRight;
  const leftDiff = tooltipLeft - priceContainerLeft;

  tooltip.style.top = `${
    tooltipTop - priceContainerTop + DISTANCE_TO_TOOLTIP
  }px`;

  if (rightDiff < WHOLESALE_PRICE_WIDTH) {
    tooltip.style.right = '6px';
    return;
  }

  if (leftDiff < WHOLESALE_PRICE_WIDTH) {
    tooltip.style.left = '6px';
    return;
  }

  tooltip.style.left = `${
    leftDiff - WHOLESALE_PRICE_WIDTH + tooltipWidth / 2
  }px`;
}
